<script lang="ts">

/**
 * A component that uses this mixin to be a tile in a masonry layout.
 */
export default {
  methods: {
    tileHeightChanged() {
      // the slot (child) component changed height.
      // from here, fire event up to the layout to handle the height change
      this.$parent.$emit('tileHeightChanged', this)
    }
  }
}
</script>
